import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button,Dialog,DialogActions,DialogContent,DialogTitle,Stack,Typography } from "@mui/material";
import { useState } from "react";
import { FormToFilling,ItemFormFilling,OcorrenciaType,SubItemFormFilling } from "../../../types/new-form-filling/types";
import SubItemFilling from "./SubItemFilling";

const MultipleSubitem = ({ webForm, itemToShow, item, setWebForm }: { webForm: FormToFilling, itemToShow: number, item: ItemFormFilling, setWebForm: Function }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [indexToDelete, setIndexToDelete] = useState<number | null>(null);
    const maxOcorrencias = item.maxOcorrencias || 0;
    const ocorrencias = item.ocorrencias || [];
    const ocorrenciasLength = ocorrencias.length;

    const handleAddOcorrencia = () => {
        const lastOcorrenciaSubItens = ocorrencias[ocorrencias.length - 1].subitens;

        const novaOcorrenciaSubItens: SubItemFormFilling[] = lastOcorrenciaSubItens.map(subitem => ({
            ...subitem,
            id: subitem.id + lastOcorrenciaSubItens.length,
            checked: false,
            assinatura: undefined,
            img: undefined,
            obs: undefined,
            ocorrencia: undefined,
            nota: undefined,
            selecao: subitem.selecao ? [...subitem.selecao] : undefined,
            selecionados: undefined,
            chamados: undefined,
            status: 'vazio',
            changes: false,
        }));

        const novaOcorrencia: OcorrenciaType = {
            nome: item.nomeOcorrencia ? `${item.nomeOcorrencia} ${ocorrencias.length + 1}` : `Ocorrência ${ocorrencias.length + 1}`,
            id: ocorrencias.length,
            subitens: novaOcorrenciaSubItens,
            itemId: item.id,
        };

        const updatedOcorrencias = [...ocorrencias, novaOcorrencia];
        setWebForm((prev: FormToFilling) => {
            const newItens = [...prev.itens];
            newItens[itemToShow] = {
                ...newItens[itemToShow],
                ocorrencias: updatedOcorrencias.map((o, i) => ({ ...o, id: i })),
            };
            return { ...prev, itens: newItens };
        });
    };

    const handleDeleteOcorrencia = () => {
        setWebForm((prev: FormToFilling) => {
            const newItens = [...prev.itens];
            const updatedOcorrencias = (newItens[itemToShow].ocorrencias || []).filter((_, index) => index !== indexToDelete);
            newItens[itemToShow] = {
                ...newItens[itemToShow],
                ocorrencias: updatedOcorrencias.map((o, i) => ({ ...o, id: i })),
            };
            return { ...prev, itens: newItens };
        });
    };

    return (
        <Stack spacing={2} width={'100%'}>
            {ocorrencias.map((ele, index) => (
                <Stack spacing={2} width={'100%'} key={index} borderTop={1} borderColor="divider" paddingTop={2}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="h5">{ele.nome}</Typography>
                        <Button onClick={() => { setIndexToDelete(index); setIsModalOpen(true); }} disabled={index === 0}>
                            <DeleteIcon color="warning" />
                        </Button>
                    </Stack>
                    {ele.subitens.map((subitem) => (
                        <Stack
                            width={'100%'}
                            key={`Item:${subitem.itemid}|Subitem:${subitem.id}`}
                            direction="column"
                            justifyContent="space-between"
                        >
                            <SubItemFilling subItem={subitem} />
                        </Stack>
                    ))}
                </Stack>
            ))
            }
            <Button variant="contained" fullWidth size="large" color="primary" onClick={handleAddOcorrencia} disabled={maxOcorrencias === 0 ? false : ocorrenciasLength >= maxOcorrencias}>
                <AddIcon />
                Adicionar Ocorrência
            </Button>
            {maxOcorrencias > 0 && <Typography variant="body2" color="textSecondary">Máximo de ocorrências: {ocorrenciasLength} / {maxOcorrencias}</Typography>}
            <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <DialogTitle>Confirmar exclusão</DialogTitle>
                <DialogContent>
                    <Typography>Tem certeza que deseja excluir esta ocorrência?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setIsModalOpen(false)} color="primary">
                        Cancelar
                    </Button>
                    <Button variant="contained" onClick={() => { handleDeleteOcorrencia(); setIsModalOpen(false); }} color="warning">
                        Excluir
                    </Button>
                </DialogActions>
            </Dialog>
        </Stack>
    );
};

export default MultipleSubitem;